import { store } from './../../../store';
import { getRegion } from './../../../utils/Region';

export const getQuantity = () => {
  const quantitySearch =
    store.getState().metadata?.search_default_quantity || '';
  if (!quantitySearch) return { ranking: 17, predictve: 17 };
  const parseQuantity = JSON.parse(quantitySearch);
  const quantityRankindPredictive =
    parseQuantity[getRegion()] || parseQuantity?.default;
  return {
    ranking: quantityRankindPredictive?.ranking,
    predictve: quantityRankindPredictive?.predictive,
  };
};
